module.exports = __webpack_public_path__ + "images/gwt-certificates.jpg";